export default __webpack_public_path__ + "static/OpenSans-VariableFont_wdth,wght-19ba637387f1d6142f551a5dd0b8f40a.ttf";